<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="slapDialog" v-model="slapDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="close">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
						</div>
						<h4 class="fs--24 fw--600 popup-header-text">
							Slap this sticker <br />
							on the stream!
						</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<template v-if="sticker.stickerType === 'TTS'">
								<AssetsTTS :sticker="sticker" :list="false" :popupMd="true" />
							</template>
							<template v-else>
								<v-img :src="getStickerImagePath(sticker)" width="100%" contain height="100"></v-img>
							</template>

							<p class="fw--600 fs--14 white--text mt-3">0 Bits for the broadcaster</p>

							<v-btn block color="primary" class="fs--15 fw--600 mt-4 mb-3 action-btn text-uppercase"
								@click="useSticker">
								Use Sticker
							</v-btn>

							<h4 class="fs--13 fw--600 mb-2 popup-footer-text">
								Broadcasters can use any available sticker for free in their own channel!
							</h4>

							<span class="fs--10 fw--600 popup-footer-text">This message can only be seen by the
								broadcaster</span>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';
import { getStickerImagePath } from '@/utils/utils';
import { mdiClose } from '@mdi/js';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';

export default {
	components: {
		AssetsTTS
	},
	props: {
		slapDialog: {
			type: Boolean,
			default: false,
		},
		sticker: Object,
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const close = () => {
			ctx.emit('onClose');
		};

		const useSticker = () => {
			ctx.emit('useSticker');
		};

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		};

		return {
			theme,
			size,
			close,
			useSticker,
			getStickerImagePath,
			cancelEvent,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
